<template>
  <section class="item-container">
    <div class="container">
      <div class="image-container">
        <img
          v-if="product.image"
          class="image"
          :src="product.image"
          height="70"
          width="70"
        />
        <img
          v-else
          class="image"
          src="../assets/image_prod.png"
          height="70"
          width="70"
        />
      </div>

      <div class="item-content">
        <div class="price-container">
          <h5 class="name">{{ product.name }}</h5>
          <div class="price-content">
            <a class="price">{{ formatMoney(product.price) }}</a>
          </div>
        </div>

        <p class="description">{{ product.description }}</p>
        <BandAidForAdditionals
          v-if="showBandAid"
          @click="innerClick(product)"
        />
      </div>
    </div>
  </section>
</template>

<script>
import BandAidForAdditionals from "./BandAidForAdditionals";
export default {
  name: "productItemForAdditionals",
  props: {
    product: {
      type: Object,
      default: () => {
        return {};
      }
    },
    showBandAid: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatMoney(price) {
      return new Intl.NumberFormat("es-ar", {
        style: "currency",
        currency: "ARS"
      }).format(price);
    },
    innerClick(product) {
      this.$emit("click", product.optionGroups);
    }

  },
  data() {
    return {};
  },
  components: {
    BandAidForAdditionals
  }
};
</script>

<style scoped>
.container {
  display: inline-flex;
  padding: 0em !important;
}
.item-container {
  padding: 0.2em;
  background: white;
  /* border-radius: 10px; */
  border-bottom: 0.5px solid #ccc;
  /* box-shadow: 1px 1px 10px black; */
  width: 99%;
  /* margin-bottom: 0.1em; */
  display: inline-block;
  -webkit-transition: box-shadow 0.2s ease-in-out;
  transition: box-shadow 0.2s ease-in-out;
}
.image-container {
  align-self: center;
}
.item-content {
  margin: 0px 0px 0px 0px !important;
  padding: 0.2em;
  width: 100%;
  margin-left: 0.5em !important;
}
.name {
  text-align: left;
  font-weight: bold;
  font-size: 1em;
  width: 75%;
}
.description {
  justify-content: left;
  text-align: left;
  width: 65%;
  display: inline-block;
}
.price-container {
  display: inline-flex;
  width: 100%;
  padding: 0em !important;
}
.price-content {
  text-align: end;
  width: 25%;
}
.price {
  color: #0D6496 !important;
}
h1,
h2 {
  font-weight: normal;
}
p {
  font-weight: lighter;
  font-size: 0.8em;
  margin: 0em !important;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #0D6496 !important;
}

.bwo-title-inline {
  display: inline;
}

.bwo-menu-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.item-content {
  margin: 20px 0px 20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/Components/ProductItemForAdditionals.vue